
import { mapState } from 'vuex'
import mbBanner from './mb-banner.vue'

export default {
  components: {
    mbBanner
  },
  computed: {
    ...mapState({
      isHdFtMobile: (state) => state.isHdFtMobile
    }),
  },
  data() {
    return {
      mbShow: true
    }
  },
  watch: {
    isHdFtMobile(nv) {
      this.mbShow = nv
    }
  }
}
